import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { CustomerAuthGuard } from '../guards/customer/customer-auth.guard';
import { LoginUserPage } from '../pages/login-user/login-user.page';
import { LoginPage } from '../pages/login/login.page';
import { AuthGuardService } from '../services/auth-guard.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'folder/:id',
    loadChildren: () => import('../folder/folder.module').then(m => m.FolderPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'clogin',
    component: LoginPage
  },
  {
    path: ':id/wizard-event',
    loadChildren: () => import('../pages/wizard-event/wizard-event.module').then(m => m.WizardEventPageModule),
    canActivate: [ CustomerAuthGuard ]
  },
  {
    path: 'login',
    component: LoginUserPage
  },

  {
    path: '**', //404 page not found
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'folder/**', //404 page not found
    redirectTo: 'login',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
